import {connect} from "react-redux";
import {lazy, Suspense} from "react";
import {ProvideTheme} from "rapids-gui-library";
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";
import GlobalLoader from "../components/GlobalLoader";
import ChallengeFooter from "../components/ChallengeFooter";
import ChallengeHeader from "../components/ChallengeHeader";

// App Pages
const ChallengePage = lazy(() => import('../pages/ChallengePage.js'));
const HelpPage = lazy(() => import('../pages/GuidePage.js'));
const ToolListPage = lazy(() => import('../pages/ToolListPage.js'));
const ModelPage = lazy(() => import('../pages/ModelPage.js'));
const UserProfilePage = lazy(() => import('../pages/UserProfilePage.js'));
const EthicsPledgePage = lazy(() => import('../pages/EthicsPledgePage.js'));
const ToolPage = lazy(() => import('../pages/ToolPage.js'));
const ToolRegisterPage = lazy(() => import('../pages/ToolRegisterPage.js'));
const DocumentsPage = lazy(() => import('../pages/DocumentsPage.js'));
const LoginPage = lazy(() => import('../pages/LoginPage.js'));
const StudiesListPage = lazy(() => import('../pages/StudiesListPage.js'));
const RegisterNewStudyPage = lazy(() => import('../pages/NewStudyPage.js'));
const StudyCardPage = lazy(() => import('../pages/StudyCardPage.js'));
const RegisterStudyPage = lazy(() => import('../pages/RegisterStudyPage.js'));
const StudyPage = lazy(() => import('../pages/StudyPage.js'));
const AlgorithmsListPage = lazy(() => import('../pages/AlgorithmsListPage.js'));
const AlgorithmRegisterPage = lazy(() => import('../pages/AlgorithmRegisterPage.js'));


function Challenge({userInfo, pageInfo, logged_in, ...props}) {
    return (
        <ProvideTheme>
            <div className='App-background'>
                <Router>
                    <ScrollToTop/>
                    <GlobalLoader/>
                    <ChallengeHeader/>
                    <Routes>
                        <Route path='home' element={<Suspense fallback={<>...</>}><ChallengePage/></Suspense>}/>
                        <Route path='guide' element={<Suspense fallback={<>...</>}><HelpPage/></Suspense>}/>
                        <Route path='ethicspledge'
                               element={<Suspense fallback={<>...</>}><EthicsPledgePage/></Suspense>}/>
                        <Route path='userprofile'
                               element={<Suspense fallback={<>...</>}><UserProfilePage/></Suspense>}/>
                                {/*<Route path='user'*/}
                                {/*       element={<Suspense fallback={<>...</>}><UserProfilePage/></Suspense>}>*/}
                                {/*    <Route path=':userid'*/}
                                {/*           element={<Suspense fallback={<>...</>}><UserProfilePage/></Suspense>}/>*/}
                                {/*</Route>*/}

                        <Route path='studies' element={<Suspense fallback={<>...</>}><StudiesListPage /></Suspense>} />
                        <Route path='registerstudy'
                               element={<Suspense fallback={<>...</>}><RegisterNewStudyPage/></Suspense>}/>
                        <Route path='editstudy/:key'
                               element={<Suspense fallback={<>...</>}><RegisterNewStudyPage/></Suspense>}/>
                        <Route path='study' element={<Suspense fallback={<>...</>}><StudyCardPage/></Suspense>}>
                            <Route path=':key'
                                   element={<Suspense fallback={<>...</>}><StudyCardPage/></Suspense>}/>
                        </Route>
                        <Route path='10.57895' element={<Suspense fallback={<>...</>}><StudyPage/></Suspense>}>
                            <Route path=':key' element={<Suspense fallback={<>...</>}><StudyPage/></Suspense>}/>
                        </Route>
                        <Route path='v1/registerstudy'
                               element={<Suspense fallback={<>...</>}><RegisterStudyPage/></Suspense>}/>
                        <Route path='v1/editstudy/:key'
                               element={<Suspense fallback={<>...</>}><RegisterStudyPage/></Suspense>}/>
                        <Route path='v1/study' element={<Suspense fallback={<>...</>}><StudyPage/></Suspense>}>
                            <Route path=':key' element={<Suspense fallback={<>...</>}><StudyPage/></Suspense>}/>
                        </Route>

                        {(pageInfo?.feature_analyst_workbench) && <>
                            <Route path='algorithms'
                                   element={<Suspense fallback={<>...</>}><AlgorithmsListPage/></Suspense>}/>
                            <Route path='registeralgorithm'
                                   element={<Suspense fallback={<>...</>}><AlgorithmRegisterPage/></Suspense>}/>
                            <Route path='editalgorithm/:key'
                                   element={<Suspense fallback={<>...</>}><AlgorithmRegisterPage/></Suspense>}/>
                            <Route path='algorithm'
                                   element={<Suspense fallback={<>...</>}><ModelPage/></Suspense>}>
                                <Route path=':key'
                                       element={<Suspense fallback={<>...</>}><ModelPage/></Suspense>}/>
                            </Route>

                            <Route path='model/presaged'
                                   element={<Suspense fallback={<>...</>}><ModelPage/></Suspense>}/>
                        </>}

                        <Route path='tools' element={<Suspense fallback={<>...</>}><ToolListPage/></Suspense>}/>
                        <Route path='registertool'
                               element={<Suspense fallback={<>...</>}><ToolRegisterPage/></Suspense>}/>
                        {(pageInfo?.tools_page) &&
                            <Route path='tool' element={<Suspense fallback={<>...</>}><ToolPage/></Suspense>}>
                                <Route path=':name'
                                       element={<Suspense fallback={<>...</>}><ToolPage/></Suspense>}/>
                            </Route>
                        }

                        <Route path='docs' element={<Suspense fallback={<>...</>}><DocumentsPage/></Suspense>}>
                            <Route path=':name' element={<Suspense fallback={<>...</>}><DocumentsPage/></Suspense>}/>
                        </Route>
                        <Route path='secure'
                               element={<Suspense fallback={<>...</>}><LoginPage key={Date.now()}/></Suspense>}/>
                        {/*<Route path='logout' element={<LogoutPage key={Date.now()} />} />*/}
                        <Route path='*' element={<Navigate replace to='home'/>}/>
                    </Routes>
                    <ChallengeFooter/>
                </Router>
            </div>
        </ProvideTheme>
    );
}

const mapStateToProps = (state) => {
    return {
        userInfo: state.userInfo,
        pageInfo: state.pageInfo,
        logged_in: state.userInfo.logged_in,
    }
}

export default connect(mapStateToProps)(Challenge);
